import { Injectable } from '@angular/core';
import { firstValueFrom, map, Observable } from 'rxjs';
import { PQRAdicionaisDto } from '../../dtos/pqr-adicionais.dto';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '../'

interface ListPQRAdicionais {
  _embedded: {
    'pqr-adicionais-manutencao-encargos': PQRAdicionaisDto[];
  };
}

@Injectable({
  providedIn: 'root',
})
export class PQRAdicionaisService {
  private apiUrl = `${environment.apiUrl}/pqr-adicionais-manutencao-encargos`;

  constructor(
    private caqRequestService: CaqRequestService
  ) {}

  buscarListaDePQRAdicionais(): Observable<PQRAdicionaisDto[]> {
    return this.caqRequestService
      .get<PQRAdicionaisDto[]>(`${this.apiUrl}/adicionais`)
      .pipe(
        map(response=>response)
      );
  }

  salvePQRAdicionais(requisicao: PQRAdicionaisDto){
    return firstValueFrom(this.caqRequestService
      .put<PQRAdicionaisDto>(`${this.apiUrl}/${requisicao.codPqrAdicionaisManutencaoEncargos}`, requisicao)
      .pipe(map((response) => response)));
  }
}
